import {
  CountryCodes,
  type CountryCode,
} from '@webapp/core/entities/external/Country'
import { formatCountryLabel } from '@webapp/core/utils/formatCountryLabel'

export interface CountryOption {
  code: CountryCode
  name: string
}

/**
 * Country dropdown options derived from the shared `CountryCodes` map,
 * alphabetised by display name. `name` is the human-readable label
 * (e.g. "Canada"); `code` is the ISO 3166-1 alpha-2 code (e.g. "CA").
 */
export const countryOptions: CountryOption[] = Object.entries(CountryCodes)
  .map(([key, code]) => ({
    code: code as CountryCode,
    name: formatCountryLabel(key),
  }))
  .sort((a, b) => a.name.localeCompare(b.name))
